'use strict';

/* eslint-disable */
angular.module('webAgro1App').controller('AuditoriaAplicacaoEdicaoCtrl', function($scope, $rootScope, $q, filterFilter, LoadingService,
  UnidadesService, RecomendacoesService, MessagesService, MaquinasService, AuditoriaAplicacaoService, $route, $routeParams,
  ProdutoModalService, AplicacoesService, ItensService, DepositosService, MESSAGE_WITHOUT_PRODUCT, MESSAGE_INVALID_PRODUCT, MIN_DOSE_VALOR, DecimalsService) {
  const percentualRecomendadoAplicado = $rootScope.parametros.percentual_recomendado_aplicado || PERCENTUAL_TOLERANCIA_PADRAO_RECOMENDADO_APLICADO;
  $scope.loadingAplicacao = false;
  $scope.calendar = {
    format: 'dd/MM/yyyy',
    startOpen: false,
    endOpen: false
  };
  $scope.datePickerOptions = {
    showWeeks: false
  };
  $scope.isDecimalV2Enabled = DecimalsService.isDecimalV2Enabled();

  const findProduto = function(itens, produto) {
    return itens.find((item) => {
      return (typeof item.id !== 'undefined' && item.id === produto.id) ||
        (typeof item.item_id !== 'undefined' && item.item_id === produto.id) ||
        (typeof item.cd_item !== 'undefined' && item.cd_item === produto.id) ||
        (typeof produto.id !== 'undefined' && produto.id === item.id) ||
        (typeof produto.item_id !== 'undefined' && produto.item_id === item.id) ||
        (typeof produto.cd_item !== 'undefined' && produto.cd_item === item.id)
    })
  };

  const buildLotesFromBalanceResponse = function(items, itemId) {
    const foundItem = items.find((i) => i.id === itemId);
    if (!foundItem || !foundItem.lotes) return [];
    return foundItem.lotes
      .filter((lote) => lote.saldo_fisico && lote.saldo_fisico.length > 0)
      .map((lote) => ({
        ...lote.saldo_fisico[0],
        nrLote: lote.nr_lote,
        fisico: lote.saldo_fisico[0].saldo_fisico,
        emUso: lote.saldo_fisico[0].saldo_em_uso,
        dataValidadeLote: lote.dt_vencimento
      }));
  };

  const getLotesSync = function(produto) {
    const deferred = $q.defer();

    if (produto.lotes) {
      deferred.resolve();
      return deferred.promise;
    }

    ItensService.listItemsBalance({ item: produto.item_id, tipo_item: produto.tipo_id || 1 })
      .then(function(response) {
        const rawLotes = buildLotesFromBalanceResponse(response.data || [], produto.item_id);
        produto.lotes = rawLotes.filter((lote) => lote.fisico + lote.emUso > 0 || lote.nrLote === produto.nr_lote);
        if (produto.nr_lote && !produto.lotes.find((lote) => lote.nrLote === produto.nr_lote)) {
          produto.lotes.push({ nrLote: produto.nr_lote, fisico: 0, emUso: 0 });
        }
        deferred.resolve();
      }, function(error) {
        console.error('Erro ao listar lotes do produto', error);
        deferred.reject();
      });

    return deferred.promise;
  }

  const updateLote = function (produto) {
    const deferred = $q.defer();

    getLotesSync(produto).then(function() {
      produto.lote = produto.lotes.find((lote) => lote.nrLote === produto.nr_lote);
      produto.nr_lote = (produto.lote || {}).nrLote;
      deferred.resolve();
    }).catch(deferred.reject);

    return deferred.promise;
  }

  const getLoteProdutoSaldo = function (produto, nrLote, itemId) {
    return (produto.lotes || []).find((lote) => lote.nr_lote === nrLote && lote.id === itemId) || {}
  }

  const updateProduto = function (produto) {

    const deferred = $q.defer();

    const foundProduct = findProduto(($scope.produtos || []), produto);
    const descricaoUnidade = produto.unidade.descricao_padrao ||
      produto.unidade.descricaoSistema ||
      produto.unidade.nomeSistema ||
      _.get(foundProduct, 'unidade.descricao_padrao');
    if (descricaoUnidade) {
      const unidade = UnidadesService.getMeasureUnitysFromDescription(descricaoUnidade);

      const unidadeDoSaldo = UnidadesService.getMeasureUnitysFromDescription(_.get(foundProduct, 'unidade.descricao_padrao'));

      if (unidadeDoSaldo.id) {
        produto.unidadeOriginal = unidadeDoSaldo;
      }

      if (unidade.id) {
        produto.unidade = unidade;
        produto.unidadeOriginal = produto.unidadeOriginal || unidade;
      }
    }

    produto.dose = $scope.isDecimalV2Enabled ? DecimalsService.truncateDoseOrQuantity(produto.dose) : +Number(produto.dose).toFixed(4);
    produto.quantidadeTotal = $scope.isDecimalV2Enabled ?
      DecimalsService.truncateDoseOrQuantity(produto.quantidadeTotal) :
      +Number(produto.quantidadeTotal).toFixed(4);
    produto.unidades = UnidadesService.getUnidadesCompativeis(produto.unidade);
    if (produto.lote) {
      produto.nr_lote = produto.lote.nrLote;
    }

    produto.old_nr_lote = produto.nr_lote;

    if (typeof produto.is_cultivar !== 'boolean') {
      produto.is_cultivar = produto.type === 'cultivar'
    }
    if (foundProduct) {
      let saldoFisico = foundProduct.saldo_fisico || 0;
      if (produto.nr_lote) {
        const itemId =  produto.item_id || produto.cd_item;
        const loteFound = getLoteProdutoSaldo(foundProduct, produto.nr_lote, itemId);
        saldoFisico = loteFound.saldo_fisico || 0;
      }
      produto.saldo_fisico = saldoFisico || 0;
      produto.saldo_em_uso = foundProduct.saldo_em_uso || 0;
      produto.saldo_receber = foundProduct.saldo_receber || 0;

      if (foundProduct.lotes != null) {
        produto.lotes = foundProduct.lotes.slice();
        if (produto.nr_lote && !produto.lotes.find((lote) => lote.nrLote === produto.nr_lote)) {
          produto.lotes.push({ nrLote: produto.nr_lote, fisico: 0, emUso: 0 });
        }
      }
    } else {
      produto.saldo_fisico = produto.saldo_fisico || 0;
      produto.saldo_em_uso = produto.saldo_em_uso || 0;
      produto.saldo_receber = produto.saldo_receber || 0;
      produto.lotes = null;
    }

    if (produto.controlaLote && produto.nr_lote) {
      updateLote(produto).then(deferred.resolve).catch(deferred.reject);
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  };

  const updateProdutos = function (produtos) {
    const promises = []
    for (let i = produtos.length - 1; i >= 0; i--) {
      promises.push(updateProduto(produtos[i]));
    }

    return $q.all(promises);
  };

  const getClassificacaoRecomendacaoAplicacao = function (application, aplicacaoParsed) {

    application.recommendation.gleba = filterFilter(application.recommendation.glebas, {id: aplicacaoParsed.gleba.id}, true)[0];
    if (!application.recommendation.gleba) {
      application.recommendation.gleba = filterFilter(application.recommendation.glebas, {gleba: {id: aplicacaoParsed.gleba.id}}, true)[0];
    }

    if (!application.recommendation.insumos) {
      application.recommendation.insumos = application.recommendation.produtos;
      delete application.recommendation.produtos;
    }

    if (aplicacaoParsed.tipoOperacao === 'operacao_semeadura') {
      application.recommendation.cultivares = filterFilter(application.recommendation.cultivares, {gleba_id: aplicacaoParsed.gleba.id}, true);
      application.recommendation.adubos = filterFilter(application.recommendation.adubos, {gleba_id: aplicacaoParsed.gleba.id}, true);
      application.recommendation.insumos = (application.recommendation.cultivares || []).concat(application.recommendation.adubos || []);
      AplicacoesService.setClassificacaoAplicadoRecomendadoSemeadura(application, percentualRecomendadoAplicado);
    } else {
      AplicacoesService.setClassificacaoAplicadoRecomendado(application, percentualRecomendadoAplicado);
    }
    return application.classificacao;
  };

  $scope.openClosePanel = function() {
    $scope.showPanel = !$scope.showPanel;
  };

  $scope.isSegundoTratamento = function() {
    return !!(($scope.aplicacao || {}).atributo_attributes || {}).segundo_tratamento;
  };

  const loadingRecommendation = function (aplicacao, aplicacaoParsed) {
    const params = {
      operacao: aplicacaoParsed.tipoOperacao,
      id: aplicacao.auditoria_aplicacao.atributo_attributes.recomendacao_id
    };

    RecomendacoesService.getRecomendacaoAplicacao(params).then(function (data) {
      if (data.data) {
        const application = {
          allData: {
            atributo: aplicacao.auditoria_aplicacao.atributo_attributes,
            itens: aplicacao.auditoria_aplicacao.itens_attributes
          },
          area: aplicacao.auditoria_aplicacao.area,
          dt_ini: moment(aplicacao.auditoria_aplicacao.dt_ini).format(MOMENT_DATE_ENGLISH_FORMAT),
          dt_fim: moment(aplicacao.auditoria_aplicacao.dt_fim).format(MOMENT_DATE_ENGLISH_FORMAT)
        };
        application.recommendation = data.data;
        aplicacaoParsed.recommendation = application.recommendation;

        aplicacaoParsed.classificacao = getClassificacaoRecomendacaoAplicacao(application, aplicacaoParsed);
      }

    }, function (error) {
      console.error('Erro ao listar recomendação', error);
    });
  };

  $scope.getRecommendationDataInicio = function(plantio) {
    const recommendation = plantio.recommendation || {};
    return ((recommendation.cultivares || []).concat(recommendation.adubos).sort(function(a, b) {
      return moment(a.data_inicio) - moment(b.data_inicio);
    })[0] || {}).data_inicio;
  };

  $scope.getRecommendationDataFim = function(plantio) {
    const recommendation = plantio.recommendation || {};
    return ((recommendation.cultivares || []).concat(recommendation.adubos).sort(function(a, b) {
      return moment(b.data_fim) - moment(a.data_fim);
    })[0] || {}).data_fim;
  };

  $scope.activeAuditoriaAplicacao = function() {
    $scope.$root.initState = null;
    $scope.$emit(EVENT_RELOAD_NOTIFICATIONS);
    $scope.loadingAplicacao = false;
    $route.updateParams({
      sidebar: null,
      activeAuditoriaAplicacao: null
    });
  };

  const initVariables = function(aplicacao = {}) {
    $scope.showPanel = false;
    $scope.produto = {
      selected: undefined
    };

    let aplicacaoParsed;

    try {
      aplicacaoParsed = (
        typeof aplicacao.auditoria_aplicacao.objeto === 'object'
          ? aplicacao.auditoria_aplicacao.objeto
          : JSON.parse(aplicacao.auditoria_aplicacao.objeto)
      );
      if ((aplicacao.auditoria_aplicacao.atributo_attributes || {}).recomendacao_id) {
        loadingRecommendation(aplicacao, aplicacaoParsed);
      }
    } catch (error) {
      console.info('Falha ao carregar recomendação', error);
      LoadingService.hideLoading();
      return $scope.activeAuditoriaAplicacao();
    }

    aplicacaoParsed.obs = ((aplicacao || {}).auditoria_aplicacao || {}).obs;

    $scope.oldQuantidade = aplicacaoParsed.quantidade
    $scope.oldQuantidadeConv = aplicacaoParsed.quantidade_conv
    $scope.isTratamentoSemente = aplicacaoParsed.tipoOperacao === 'operacao_tratamento_semente';
    $scope.isCorrecaoSolo = aplicacaoParsed.tipoOperacao === 'operacao_correcao_solo';
    $scope.temRecomendacaoTratamento = (aplicacaoParsed.atributo_attributes || {}).recomendacao_semeadura_id;

    setDates(aplicacao, aplicacaoParsed);
    aplicacaoParsed.areaAplicada = Number(aplicacaoParsed.areaAplicada);

    $scope.dataBaseParaEstoque = aplicacaoParsed.dataInicio || aplicacaoParsed.dt_ini;
    $scope.dataBaseParaEstoque = moment($scope.dataBaseParaEstoque); // Parse para datas em timestamp

    if (aplicacaoParsed.parametros) {
      aplicacaoParsed.nr_tanques = Number(aplicacaoParsed.parametros.tanques);
      aplicacaoParsed.parametros.vazao = Number(aplicacaoParsed.parametros.vazao);
      aplicacaoParsed.parametros.capacidade_tanque = Number(aplicacaoParsed.parametros.capacidade_tanque);
    }

    if (aplicacaoParsed.condicoes) {
      if (aplicacaoParsed.condicoes.umidade) {
        aplicacaoParsed.condicoes.umidade.final = Number(aplicacaoParsed.condicoes.umidade.final);
      }
      if (aplicacaoParsed.condicoes.temperatura) {
        aplicacaoParsed.condicoes.temperatura.final = Number(aplicacaoParsed.condicoes.temperatura.final);
      }
      aplicacaoParsed.condicoes.horasSemChuva = Number(aplicacaoParsed.condicoes.horasSemChuva);
      if (aplicacaoParsed.condicoes.vento) {
        aplicacaoParsed.condicoes.vento.maxima = Number(aplicacaoParsed.condicoes.vento.maxima);
      }
    }
    if (!aplicacaoParsed) { return; }

    // Busca todos os produtos para pegar a quantidade em estoque
    const produtosIds = _.uniq((aplicacaoParsed.produtos).map(function (produto) {
      return produto.item_id || produto.cd_item || produto.id;
    }));

    $scope.searchProdutos({
      ids: produtosIds,
      data: $scope.dataBaseParaEstoque
    }).then(function() {
      $scope.aplicacao = aplicacaoParsed;
      $scope.id = aplicacao.id;

      updateProdutos(aplicacaoParsed.produtos).then(function() {
        $scope.fatorDose = aplicacaoParsed.fatorDose || 1;
        if ($scope.isTratamentoSemente) {
          $scope.aplicacao.quantidade = +$scope.aplicacao.quantidade;
          LoadingService.hideLoading();
          return;
        }

        $scope.aplicacao.safra = filterFilter($scope.$root.safras, { id: $scope.aplicacao.params.safraId }, true)[0];
        let maquinasFunction = MaquinasService.listSprayers;
        if ($scope.aplicacao.tipoOperacao !== 'operacao_pulverizacao') {
          maquinasFunction = MaquinasService.list;
        }
        return getAtividadesPeriodo().then(function() {
          $scope.aplicacao.atividade = filterFilter($scope.atividades, { id: (($scope.aplicacao.params || {}).atividade || {}).id }, true)[0];
          return maquinasFunction().then(function(result) {
            $scope.sprayers = result.data;
          });
        });
      });
    }).catch(function(error) {
      console.error('Falha ao localizar produtos', error);
    }).finally(function() {
      hasDepositInUse();
      $scope.loadingAplicacao = false;
    });
  };

  function setDates(aplicacao, aplicacaoParsed) {
    if ($scope.isTratamentoSemente) { // tratamento de sementes
      if (aplicacaoParsed.atributo_attributes.data_hora_fim) {
        aplicacaoParsed.hr_fim = moment(aplicacaoParsed.atributo_attributes.data_hora_fim).format(HOUR_FORMAT);
        aplicacaoParsed.atributo_attributes.data_hora_fim = moment(aplicacaoParsed.atributo_attributes.data_hora_fim).toDate();
      }
      if (aplicacaoParsed.atributo_attributes.data_hora_inicio) {
        aplicacaoParsed.hr_ini = moment(aplicacaoParsed.atributo_attributes.data_hora_inicio).format(HOUR_FORMAT);
        aplicacaoParsed.atributo_attributes.data_hora_inicio = moment(aplicacaoParsed.atributo_attributes.data_hora_inicio).toDate();
      }
    } else { // outras aplicações
      aplicacaoParsed.hr_ini = moment(aplicacao.auditoria_aplicacao.atributo_attributes.iniciado_em).format(HOUR_FORMAT);
      aplicacaoParsed.hr_fim = moment(aplicacao.auditoria_aplicacao.atributo_attributes.encerrado_em).format(HOUR_FORMAT);
      aplicacaoParsed.dt_ini = moment(aplicacao.auditoria_aplicacao.dt_ini).toDate();
      aplicacaoParsed.dt_fim = moment(aplicacao.auditoria_aplicacao.dt_fim).toDate();
    }
  }

  function getAtividadesPeriodo() {
    const deferred = $q.defer();

    RecomendacoesService.listAtividadesPeriodo({ ignore_open: true, safra: $scope.aplicacao.safra.id }).then(function(data) {
      $scope.atividades = data;
      deferred.resolve();
    }, function() {
      MessagesService.alert('Ocorreu um erro ao buscar as culturas da safra selecionada.');
      deferred.reject();
    });

    return deferred.promise;
  }

  $scope.removeProduto = function(index) {
    $scope.aplicacao.produtos.splice(index, 1);
  };

  $scope.addProduto = function($select) {
    if ($select && $select.id) {
      const produto = findProduto($scope.aplicacao.produtos, $select);
      if (produto && !$select.controla_lote) {
        MessagesService.alert('Este produto já foi inserido na auditoria atual');
      } else {
        $select.item_id = $select.id;
        $select.tipo_id = $select.tipo;
        $scope.changeDose($select);
        updateProduto($select).then(function() {
          const produto = angular.copy($select);
          $scope.aplicacao.produtos.push(produto);        
        })
      }
    }
    $scope.produto.selected = undefined;
  };

  $scope.getLotes = function(produto) {
    if (produto.loadingLotes || produto.lotes) {
        return (produto.lotes || []).filter((lote) => {
          const loteAlreadySelectedBySameProduct = $scope.aplicacao.produtos.some((newDataProduct) => {
            if (newDataProduct === produto) {
              return false;
            }
            const sameProduct =
            newDataProduct.id === produto.item_id ||
            newDataProduct.item_id === produto.item_id;
            return sameProduct && newDataProduct.nr_lote === lote.nrLote;
          });

          return !loteAlreadySelectedBySameProduct && lote.fisico + lote.emUso > 0;
        });
      }

    produto.loadingLotes = true;

    ItensService.listItemsBalance({ item: produto.item_id, tipo_item: produto.tipo_id || 1 })
      .then(function(response) {
        const rawLotes = buildLotesFromBalanceResponse(response.data || [], produto.item_id);
        produto.lotes = rawLotes.filter((lote) => lote.fisico + lote.emUso > 0);
      }, function(error) {
        console.error('Erro ao listar lotes do produto', error);
      }).finally(function() {
        produto.loadingLotes = false;
      });
  };

  $scope.addLote = function($select, produto) {
    produto.lote = $select;
    produto.nr_lote = produto.lote ? produto.lote.nrLote : undefined;
    $scope.produto.selected = undefined;
  };

  $scope.stockIsNegative = function(produto) {
    const controlaLote = produto.controla_lote || produto.controlaLote;
    if (!$rootScope.parametros.tem_controle_de_estoque || (controlaLote && !produto.lote)) {
      return false;
    }
    return ItensService.stockIsNegative(produto, $scope.hasDepositInUse);
  };

  function hasDepositInUse() {
    const propriedadeId = ($scope.aplicacao.params.propriedade || {}).id ||
    $scope.aplicacao.atributo_attributes.propriedade_id;
    DepositosService.hasDepositInUse(propriedadeId).then((result) => {
      $scope.hasDepositInUse = result.data;
    });
  }

  const toNumber = function(str) {
    const ret = Number((str || '').toString().replace(',', '.'));

    if (isNaN(ret)) {
      throw ('Valor inválido');
    }

    return ret;
  };

  const getArea = function(produto) {
    if ($scope.isTratamentoSemente) {
      return $scope.aplicacao.quantidade;
    }
    return produto.area || toNumber($scope.aplicacao.areaAplicada);
  };

  $scope.changeArea = function() {
    const areaProduto = getArea(produto);
    $scope.aplicacao.produtos.forEach(function(produto) {
      if ($scope.isDecimalV2Enabled) {
        const quantidadeTotalCalculated = DecimalsService.roundForCalculation(
          +produto.dose * areaProduto,
          DecimalsService.DECIMAL_PLACES_CALCULATION
        );

        produto.quantidadeTotal = DecimalsService.truncateDoseOrQuantity(quantidadeTotalCalculated);
      } else {
        produto.quantidadeTotal = Number((toNumber(produto.dose) * areaProduto).toFixed(4));
      }
    });
  };

  $scope.changeQuantidade = function() {
    if ($scope.oldQuantidadeConv && $scope.aplicacao.quantidade && $scope.oldQuantidade) {
      $scope.aplicacao.quantidade_conv = $scope.aplicacao.quantidade * ($scope.oldQuantidadeConv / $scope.oldQuantidade)
    }
    $scope.aplicacao.produtos.forEach($scope.changeDose);
  };

  $scope.changeDose = function(produto) {
    const areaProduto = getArea(produto);
    if ($scope.isDecimalV2Enabled) {
      const quantidadeTotal = DecimalsService.roundForCalculation(
        +produto.dose * areaProduto,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      );
      produto.quantidadeTotal = DecimalsService.truncateDoseOrQuantity(quantidadeTotal) / $scope.fatorDose;
    } else {
      produto.quantidadeTotal = Number((toNumber(produto.dose) * areaProduto).toFixed(4)) / $scope.fatorDose;
    }
  };

  $scope.fixDose = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._doseOnFocus !== produto.dose) {
      produto.dose = DecimalsService.truncateDoseOrQuantity(produto.dose);
      $scope.changeDose(produto);
      delete produto._doseOnFocus;
    } else {
      produto.dose = +Number(produto.dose).toFixed(4);
    }
  };

  $scope.changeQuantidadeTotal = function(produto) {
    const areaProduto = getArea(produto);
    if ($scope.isDecimalV2Enabled) {
      const dose = DecimalsService.roundForCalculation(
        +produto.quantidadeTotal / areaProduto,
        DecimalsService.DECIMAL_PLACES_CALCULATION
      ) * $scope.fatorDose;
      produto.dose = DecimalsService.truncateDoseOrQuantity(dose);
    } else {
      produto.dose = Number((toNumber(produto.quantidadeTotal) / areaProduto).toFixed(4) * $scope.fatorDose);
    }
  };

  $scope.fixQuantidadeTotal = function(produto) {
    if ($scope.isDecimalV2Enabled && produto._qtTotalOnFocus !== produto.quantidadeTotal) {
      produto.quantidadeTotal = DecimalsService.truncateDoseOrQuantity(produto.quantidadeTotal);
      $scope.changeQuantidadeTotal(produto);
      delete produto._qtTotalOnFocus;
    } else {
      produto.quantidadeTotal = +Number(produto.quantidadeTotal).toFixed(4);
    }
  };

  $scope.startEditDose = function(produto) {
    produto._doseOnFocus = +produto.dose;
  };

  $scope.startEditQuantidadeTotal = function(produto) {
    produto._qtTotalOnFocus = +produto.quantidadeTotal;
  };

  $scope.cancel = function() {
    clearScopeDate();
    $scope.activeAuditoriaAplicacao();
  };

  $scope.save = function(form) {
    const isValid = validateAplicacao(form);

    if (!isValid) {
      return;
    }

    LoadingService.showLoading();

    AuditoriaAplicacaoService.save($scope.id, $scope.aplicacao)
      .then(saveSuccess)
      .catch(function() {
        MessagesService.alert('Falha ao salvar aplicação, tente novamente.');
      })
      .finally(LoadingService.hideLoading);
  };

  function saveSuccess() {
    MessagesService.alert('Aplicação editada com sucesso!');
    $scope.activeAuditoriaAplicacao();
    $route.reload();
  }

  function validSeedingProducts () {
    const { tipoOperacao, produtos } = $scope.aplicacao;

    return (
      tipoOperacao !== 'operacao_semeadura'
      || produtos.some(({ is_cultivar }) => is_cultivar)
    )
  }

  function validateAplicacao(form) {
    let isValid = true;
    if (form.$invalid) {
      isValid = false;
    }

    if (!($scope.aplicacao.produtos || []).length) {
      MessagesService.alert('Informe pelo menos um produto.');
      isValid = false;
    }

    if(!validateUniqueLotesByProduto()) {
      MessagesService.alert('Um produto não deve possuir o mesmo lote informado mais de uma vez.');
      isValid = false;
    }

    const produtosValidos = validateProdutos();

    if (!produtosValidos.valid) {
      MessagesService.alert(produtosValidos.message);
      return;
    }

    if (!validateLoteProdutos()) {
      MessagesService.alert('Informe o número do lote para todos produtos.');
      isValid = false;
    }

    if (!validSeedingProducts()) {
      MessagesService.alert('Uma semeadura deve possuir pelo menos um produto do tipo "cultivar"');
      isValid = false;
    }

    if (!validateDates()) {
      MessagesService.alert('Verifique a data final e inicial informadas. A data inicial não pode ser após a final, nem a final antes da inicial.');
      isValid = false;
    }

    return isValid;
  }

  const validateProdutos = function() {

    if ($scope.aplicacao.produtos.length === 0) {
      return { valid: false, message: MESSAGE_WITHOUT_PRODUCT };
    }

    const hasProdutosInvalidos = $scope.aplicacao.produtos.some(function(produto) {
        const unidadeInvalida = !(produto.unidade || {}).abreviatura;

        if ($scope.isSegundoTratamento()) {
          return !produto.quantidadeTotal || unidadeInvalida;
        }

        const doseInvalida = !produto.dose || produto.dose < MIN_DOSE_VALOR;
        return doseInvalida || unidadeInvalida;
    });
    

    if (hasProdutosInvalidos) {
      return { valid: false, message: MESSAGE_INVALID_PRODUCT };
    }

    return { valid: true };
  };

  const validateUniqueLotesByProduto = () => {
    const produtoWithLotes = $scope.aplicacao.produtos.filter((aplicacaoProdutos) => aplicacaoProdutos.lotes && aplicacaoProdutos.lotes.length)
    const produtosIndexados = produtoWithLotes.reduce(
      (acc, produto) => {
          const produtoAgrupado = acc[produto.item_id] || [];
          return { ...acc, [produto.item_id]: [...produtoAgrupado, produto] };
    }, {});

    return produtoWithLotes.every((produto) => {
      const loteIds = produtosIndexados[produto.item_id].map((produtoIndex) => produtoIndex.nr_lote)
      const uniqueLoteIds = _.uniq(loteIds);
      return loteIds.length === uniqueLoteIds.length;
    })
  }

  function validateLoteProdutos() {
    return ($scope.aplicacao.produtos || []).reduce(function(result, produto) {
      const controlaLote = produto.controlaLote || produto.controla_lote;
      return result && (!controlaLote || produto.lote);
    }, true);
  }

  function validateDates() {
    if (!$scope.isTratamentoSemente) {
      return moment($scope.aplicacao.dt_ini).isSameOrBefore($scope.aplicacao.dt_fim);
    }
    return moment($scope.aplicacao.atributo_attributes.data_hora_inicio)
      .isSameOrBefore($scope.aplicacao.atributo_attributes.data_hora_fim);
  }

  $scope.$on('edicaoAuditoriaAplicacao', function(_event, aplicacao) {
    $scope.loadingAplicacao = true;
    $rootScope.initialize.then(function() {
      const data = aplicacao || $scope.data;
      if (!data && $routeParams.activeAuditoriaAplicacao) {
        AuditoriaAplicacaoService.get($routeParams.activeAuditoriaAplicacao)
          .then(function(response) { initVariables(response.data); })
          .catch(function() {
            MessagesService.alert('Falha ao carregar a aplicação.');
            $scope.activeAuditoriaAplicacao();
          });
      } else {
        initVariables(data);
      }
    });
  });

  $scope.setUnidade = function($event, produto, unidade) {
    $event.preventDefault();
    produto.unidade = unidade;
  };

  function getOperacaoItemEstoque() {
    let operacao = null;

    if ($scope.aplicacao) {
      if ($scope.aplicacao.tipoOperacao === 'operacao_semeadura') {
        operacao = 'cultivar,outros_semeadura';
      } else if ($scope.aplicacao.tipoOperacao === 'operacao_correcao_solo') {
        operacao = 'correcao_solo';
      } else if ($scope.aplicacao.tipoOperacao === 'operacao_adubacao') {
        operacao = 'outros_semeadura';
      }
    }

    return operacao;
  }

  $scope.searchProdutos = function($select) {
    if (!$select.ids && !$select.search) {
      return;
    }

    $scope.searchProduto = $select.search;
    $scope.produtos = null;
    if ($select.ids || $scope.searchProduto.length >= 3) {
      $scope.loadingProdutos = true;

      const params = {
        descricao: $select.search,
        operacao_item: 'pulverizacao'
      };

      if($scope.aplicacao && $scope.aplicacao.gleba) {
        params.gleba_id = $scope.aplicacao.gleba.id
      }

      if (getOperacaoItemEstoque()) {
        params.operacao_item = getOperacaoItemEstoque();
      }

      if ($select.ids) {
        params.tipo_item = 1;
        params.item = $select.ids.join(',');
      }

      params.data = $scope.dataBaseParaEstoque;

      return RecomendacoesService.listItemsBalance(params).then(function(data) {
        if (!params.descricao) {
          const itens = data.data.flatMap(function(item) {
            if (!item.lotes) return [];
            return item.lotes
              .filter((lote) => lote.saldo_fisico && lote.saldo_fisico.length > 0)
              .map((lote) => ({
                ...lote.saldo_fisico[0],
                nrLote: lote.saldo_fisico[0].nr_lote,
                fisico: lote.saldo_fisico[0].saldo_fisico,
                emUso: lote.saldo_fisico[0].saldo_em_uso,
                dataValidadeLote: lote.dt_vencimento
              }));
          });
  
          data.data.forEach((itemEstoque) => {
            itemEstoque.lotes = itens.filter((item) => item.id == itemEstoque.id);
          });
        } else {
          data.data.forEach((itemEstoque) => {
            itemEstoque.lotes = null;
          });
        }
  
        $scope.produtos = data.data || [];
      }).catch(function(error) {
        console.error('Erro ao buscar produtos', error);
        MessagesService.alert('Erro ao carregar produtos');
      }).finally(function() {
        $scope.loadingProdutos = false;
      });
    }
  };

  function fetchAuditoriaProducts(descricao) {
    const params = { ...getModalParams(), ...(descricao ? { descricao } : {}) };
    return RecomendacoesService.listItemsBalance(params)
      .then(function(data) {
        return data.data || [];
      });
  }

  function fetchAuditoriaByIds(ids) {
    return RecomendacoesService.listItemsBalance({
      ...getModalParams(),
      item: ids.join(','),
      tipo_item: 1
    }).then(function(data) {
      return data.data || [];
    });
  }

  $scope.openProductModal = function() {
    LoadingService.showLoading();
    RecomendacoesService.listItemsBalance(getModalParams())
      .then(function(data) {
        return ProdutoModalService.buildModalList(
          data.data, $scope.aplicacao.produtos, fetchAuditoriaByIds
        );
      })
      .then(function(fullList) {
        LoadingService.hideLoading();
        const selectedProducts = ProdutoModalService.findSelected(
          fullList, $scope.aplicacao.produtos
        );
        return ProdutoModalService.open(fullList, selectedProducts, {
          fetchProducts: fetchAuditoriaProducts
        });
      })
      .then((products) => ProdutoModalService.mergeProducts(products, $scope.aplicacao.produtos))
      .then((products) => {
        products.forEach((prod) => $scope.addProduto(prod));
      })
      .catch(function(error) {
        LoadingService.hideLoading();
        if (error) {
          console.error('Erro ao buscar produtos', error);
          MessagesService.alert('Erro ao carregar produtos');
        }
      });
  };

  function getModalParams() {
    return {
      operacao_item: getOperacaoItemEstoque() || 'pulverizacao',
      data: $scope.dataBaseParaEstoque
    };
  }

  function clearScopeDate() {
    $scope.aplicacao = null;
    $scope.sprayers = null;
    $scope.glebasAtividade = null;
    $scope.produtos = null;
    $scope.loadingAplicacao = true;
  }

  $scope.specifyProductArea = function(produto) {
    const deferred = $q.defer();
    MessagesService.prompt('Área aplicada de ' + produto.descricao).then(function(data) {
      try {
        data = toNumber(data);
        if (data <= 0 || data > toNumber($scope.aplicacao.areaAplicada)) {
          MessagesService.alert('Valor inválido para área aplicada');
          deferred.reject();
        } else {
          produto.area = data;

          if (data === toNumber($scope.aplicacao.areaAplicada)) {
            produto.area = null;
          }
          $scope.changeDose(produto);
          deferred.resolve();
        }
      } catch (error) {
        MessagesService.alert('Valor inválido para área aplicada');
        deferred.reject();
      }
    }, deferred.reject);

    return deferred.promise;
  };

  $scope.changeConsumo = function() {
    if (!!$scope.aplicacao.parametros.vazao && $scope.aplicacao.nr_tanques) {
      const area = ($scope.aplicacao.nr_tanques * $scope.aplicacao.parametros.capacidade_tanque) / $scope.aplicacao.parametros.vazao;
      $scope.aplicacao.parametros.tanques = $scope.aplicacao.nr_tanques;
      $scope.aplicacao.areaAplicada = $scope.isDecimalV2Enabled ? DecimalsService.truncateArea(area) : Number(area.toFixed(2));
      $scope.changeArea();
    }
  }

  $scope.$on('$routeUpdate', function() {
    if ($scope.aplicacao && $routeParams.activeAuditoriaAplicacao !== $scope.aplicacao.id) {
      clearScopeDate();
      initVariables($scope.data);
    }
  });
});
